module.exports = __webpack_public_path__ + "img/what-icon.32b0c0fb.svg";